module.exports = __webpack_public_path__ + "static/img/near.52906207.jpg";